import { Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import 'swiper/modules/navigation/navigation.min.css'
import { useTranslation } from 'react-i18next'
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const CmsSlider = () => {
    const { t, i18n } = useTranslation();
    const { tenantLogo, tenantName } = useSelector((state: RootState) => state.global);
    const displayName = tenantName || "Pinvest";
    const isFa = i18n.language == "fa"
    return (<Swiper
        className={`md:w-1/2 hidden m-0 lg:block ${isFa ? "rounded-r-3xl" : "rounded-l-3xl"}`}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{ clickable: true, el: '.swiper-pagination', }}
        // onSlideChange={() => console.log('slide change')}
        // onSwiper={(swiper) => console.log(swiper)}
    >
        <SwiperSlide>
            <div className="relative w-full h-full">
                <div className="absolute  z-10 h-full w-full opacity-80" style={{ background: "#313F4C" }}>
                </div>
                <div className="absolute  z-20 h-full w-full" >
                    <img 
                        className="mx-auto mt-20 h-20 w-20 object-contain" 
                        src={tenantLogo || "/logo.png"}
                    />
                    <h2 className="text-center text-xl mt-2  text-white">{t("appTitle", { tenantName: t(displayName) })}</h2>
                    <h2 className="text-center text-sm mt-40  text-white p-4"> {t("FirstSentence", { tenantName: t(displayName) })}</h2>
                </div>
                <img className="absolute z-5 w-full h-full" src="/asset/pic1.jpeg"></img>
            </div>
        </SwiperSlide>
        <SwiperSlide>
            <div className="relative w-full h-full">
                <div className="absolute  z-10 h-full w-full opacity-80" style={{ background: "#313F4C" }}>
                </div>
                <div className="absolute  z-20 h-full w-full" >
                    <img className=" mx-auto mt-20  h-20 w-20 object-contain" src={tenantLogo || "/logo.png"}></img>
                    <h2 className="text-center text-xl mt-2  text-white">{t("appTitle", { tenantName: displayName })}</h2>
                    <h2 className="text-center text-sm mt-40  text-white p-4"> {t("SecondSentence", { tenantName: displayName })}</h2>

                </div>
                <img className="absolute z-5 w-full h-full" src="/asset/pic2.jpeg"></img>
            </div>
        </SwiperSlide>
        <SwiperSlide>
            <div className="relative w-full h-full">
                <div className="absolute  z-10 h-full w-full opacity-80" style={{ background: "#313F4C" }}>
                </div>
                <div className="absolute  z-20 h-full w-full" >
                    <img className=" mx-auto mt-20  h-20 w-20 object-contain" src={tenantLogo || "/logo.png"}></img>
                    <h2 className="text-center text-xl mt-2  text-white">{t("appTitle", { tenantName: displayName })}</h2>
                    <h2 className="text-center text-sm mt-40  text-white p-4"> {t("ThirdSentence", { tenantName: displayName })}</h2>

                </div>
                <img className="absolute z-5 w-full h-full" src="/asset/pic3.jpeg"></img>
            </div>
        </SwiperSlide>

    </Swiper>)

}
export default CmsSlider